import { Typography } from "@mui/material";
import LegalPageLayout from "./LegalPageLayout";

export default function PrivacyPage() {
  return (
    <LegalPageLayout title="Privacy Policy" updatedAt="August 9, 2026">
      <Typography variant="body1">
        This Privacy Policy explains how Athriv Technologies ("Athriv", "we", "us") collects,
        uses, and protects information when you use the Athriv Asset Portal ("Service").
      </Typography>

      <Typography component="h2">1. Information We Collect</Typography>
      <Typography>
        Account information: name, email address, and role, either entered directly or provided
        by Microsoft when you sign in with SSO.
      </Typography>
      <Typography>
        Customer Data: asset records, assignments, maintenance history, and related information
        your organization enters into the Service.
      </Typography>
      <Typography>
        Usage data: basic technical logs (timestamps, IP address, browser type) used for security
        and troubleshooting.
      </Typography>

      <Typography component="h2">2. How We Use Information</Typography>
      <Typography>
        We use collected information to operate and secure the Service, authenticate users,
        send transactional emails (invites, password resets, notifications), and respond to
        support requests. We do not sell personal information.
      </Typography>

      <Typography component="h2">3. Data Isolation</Typography>
      <Typography>
        Each organization's data is stored in a logically separate tenant. Users from one
        organization cannot access another organization's data.
      </Typography>

      <Typography component="h2">4. Third-Party Services</Typography>
      <Typography>
        We use Microsoft Azure to host the Service and its database, and Azure Communication
        Services to send transactional email. If your organization uses Microsoft single sign-on,
        Microsoft processes your sign-in according to its own privacy terms.
      </Typography>

      <Typography component="h2">5. Data Retention and Deletion</Typography>
      <Typography>
        Customer Data is retained for as long as the account is active. An account administrator
        may permanently delete the organization's account and all associated data at any time
        from Settings; this action is immediate and irreversible.
      </Typography>

      <Typography component="h2">6. Security</Typography>
      <Typography>
        We use encryption in transit (HTTPS/TLS), role-based access control, and audit logging of
        key actions. No method of transmission or storage is 100% secure, but we work to protect
        information using industry-standard practices.
      </Typography>

      <Typography component="h2">7. Your Choices</Typography>
      <Typography>
        You may access, correct, export, or request deletion of your organization's data at any
        time. Contact your organization's administrator or reach us directly at privacy@athriv.com.
      </Typography>

      <Typography component="h2">8. Changes to This Policy</Typography>
      <Typography>
        We may update this Privacy Policy from time to time. Material changes will be reflected
        by updating the "Last updated" date above.
      </Typography>

      <Typography component="h2">9. Contact</Typography>
      <Typography>
        Questions about this Privacy Policy can be sent to privacy@athriv.com.
      </Typography>
    </LegalPageLayout>
  );
}
